import { HicapsConnectTerminal } from '@principle-theorem/principle-core';
import {
  IHicapsConnectMerchant,
  IHicapsConnectTerminalV2,
  IPractice,
} from '@principle-theorem/principle-core/interfaces';
import { Firestore, WithRef } from '@principle-theorem/shared';
import { ISelectedHicapsConnectTerminal } from '../selected-hicaps-connect-terminal';
import { IHicapsConnectRouteCandidate } from './hicaps-connect-v2-routing';

/**
 * Bridges the V2 terminal/merchant model into the flat terminal shape the
 * HICAPS transaction pipeline consumes, so the payment path does not have to
 * know which of the two models a practice is on.
 */
export class HicapsConnectV2Adapter {
  /**
   * Flattens a terminal, the merchant chosen on it and the bridge chosen to
   * reach it into the single terminal record a transaction is built from.
   */
  static toSelectedTerminal(
    terminal: WithRef<IHicapsConnectTerminalV2>,
    merchantId: string,
    merchant: WithRef<IHicapsConnectMerchant> | undefined,
    chosen: IHicapsConnectRouteCandidate
  ): ISelectedHicapsConnectTerminal {
    return {
      name: terminal.name,
      terminalId: chosen.edge.serverUrl,
      merchantId,
      bridgeDevice: chosen.bridgeDevice.ref,
      practitionerRef: merchant?.practitionerRef,
      deleted: terminal.deleted,
      lastActive: HicapsConnectTerminal.lastActive(terminal),
      practiceRef: Firestore.getParentDocRef<IPractice>(terminal.ref),
    };
  }
}
